// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-visible {
  -ms-overflow-style: auto !important; /* For IE and Edge */
  scrollbar-width: auto !important; /* For Firefox */
  overflow-y: scroll; /* Ensure vertical scrollbar is enabled */
  /* Additional styling for WebKit-based browsers */
}
.scroll-visible::-webkit-scrollbar {
  width: 8px;
}
.scroll-visible::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}
.scroll-visible::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

.list-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-y: scroll;
  padding: 1em;
  padding-bottom: 0;
  flex: 1 1;
  height: 100%;
  box-sizing: border-box;
}
.list-container table {
  width: 100%;
}
.list-container table img {
  width: 3em;
  height: 3em;
  border-radius: 0.5em;
  object-fit: cover;
}
.list-container table td,
.list-container table th {
  font-size: 0.875em;
  padding: 0.5em;
  color: black;
}
.list-container table tr:not(:last-child):not(:first-child) {
  border-block: 2px solid #f3f6f9;
}
.list-container table thead,
.list-container table tbody {
  width: 100%;
}
.list-container .btn-update {
  background-color: rgb(143, 0, 60) !important;
  border: none;
  font-family: "Rubik";
}
.list-container .btn-update .btn-primary {
  background-color: rgb(143, 0, 60);
  border: none;
  font-family: "Rubik";
}
.list-container .btn-update:hover {
  opacity: 0.8;
  background-color: rgb(143, 0, 60);
  border: none;
  font-family: "Rubik";
}
.list-container .btn-update:disabled {
  background-color: rgb(199, 199, 199) !important;
  border: none;
  font-family: "Rubik";
}
.list-container .btn-primary {
  background-color: rgb(143, 0, 60);
  border: none;
  font-family: "Rubik";
}
.list-container .btn-primary:active {
  background-color: rgb(143, 0, 60);
  border: none;
  font-family: "Rubik";
}

.list-header-input-number {
  width: 70px;
}

.row-slideDuration {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-right: 4rem;
}
.row-slideDuration input {
  margin: 15px;
}

.list {
  background-color: #fff;
  border-radius: 1em;
  padding: 1em;
  width: 95%;
  margin-bottom: 3em;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-block: 1em;
  flex-wrap: wrap;
}
.list-header-title {
  font-size: 1.1em;
  font-weight: bold;
  margin-left: 1em;
}
.list-header-action-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1em;
}
.list-header-filter-icon {
  font-size: 2em !important;
  color: black;
  cursor: pointer;
}
.list-header-filter-icon:hover {
  color: #8f003c;
}
.list-header-input {
  padding: 1em;
  border-radius: 0.5em;
  border: 1px solid #dcdcdc;
  margin-top: 0.3em;
  height: 2.5em;
}
.list-header-input:active, .list-header-input:focus {
  box-shadow: none;
  border-color: #8f003c;
}
.list-header-action, .list-header-action:focus, .list-header-action:hover, .list-header-action:active {
  text-decoration: none;
  outline: none;
  box-shadow: none !important;
  background-color: #fff;
  border: 1px solid #8f003c;
  color: #8f003c;
  padding-inline: 2em;
  border-radius: 8px;
  height: 2em;
  line-height: 2em;
}
.list-header-action:hover {
  background-color: #8f003c;
  color: #fff;
}

.list-headers {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 1em;
}

.list-header-main {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1em;
}

.list-element {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 2px solid #eeedec;
  padding: 6px;
  flex: 1 1;
}
.list-element-fields {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 1em;
}
.list-element-action {
  font-size: 2em !important;
  color: #777776;
  cursor: pointer;
}
.list-element-action:hover {
  color: #8f003c;
}
.list-element-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5em;
}
.list-element-primary-text {
  font-weight: normal;
}
.list-element-secondary-text {
  color: #777776;
}
.list-element-text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
}
.list-element-text-container > .list-element-primary-text {
  display: block;
  width: 38em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list-element-text-container > .list-element-primary {
  display: block;
  width: 11em;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.sort-tabs > li > button {
  width: 8em;
}

.filter-parameters {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 1em;
  padding: 1em;
}

.filter-general {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 1em;
  padding: 1em;
  border-bottom: 1px solid #e2e5e7;
}

.filter-option {
  cursor: pointer;
  width: 100%;
  height: 2em;
  padding: 0.1em;
  padding-left: 1em;
  line-height: 2em;
  box-sizing: border-box;
}

.filter-option:hover {
  background-color: #f8b8d3;
  cursor: pointer;
}

.filter-selected-option {
  background-color: #c4145d !important;
  cursor: pointer;
  color: white;
}

.filter-input {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 1em;
}

.list-filter-input {
  width: 100%;
  padding: 1em;
  border-radius: 0.5em;
  border: 1px solid #dcdcdc;
  margin-top: 0.3em;
  height: 2.5em;
}
.list-filter-input:active, .list-filter-input:focus {
  box-shadow: none;
  border-color: #8f003c;
}

.filter-member-name {
  font-weight: bold;
  max-width: 40%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.filter-member-type {
  color: #777776;
  max-width: 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.filter-member-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: 2em;
  line-height: 3em;
  position: relative;
}

.filter-member-row:hover {
  cursor: pointer;
}

.filter-member-row:hover::before {
  content: "";
  position: absolute;
  left: 0em;
  top: 1.25em;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 4px 0 4px 6.9px;
  border-color: transparent transparent transparent #648acf;
}

.filter-member-selected {
  color: #8f003c;
}

.filter-member-selected::before {
  content: "";
  position: absolute;
  left: 0em;
  top: 1.25em;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 4px 0 4px 6.9px;
  border-color: transparent transparent transparent #648acf;
}

.sort-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2em;
  font-size: 0.675em;
  border-radius: 0.5em;
  border: 1px solid #e2e5e7;
  height: 3em;
  padding-inline: 0.225em;
  width: 20em;
  align-self: center;
}

.sort-button {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 100%;
  border-radius: 0.5em;
  height: 2.5em;
}

.sort-buttons-disabled {
  display: none;
}

.sort-button-selected {
  background-color: #8f003c;
  color: #fff;
}

.filter-general-container {
  display: flex;
  flex-direction: column;
}

.filter-title {
  font-size: 0.75em;
  margin-left: 2.6em;
}

.list-loading-spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-block: 2em;
  width: 100%;
}

.list-loading-spinner {
  margin-block: 2em;
}

.list-empty {
  align-self: center;
  color: #8f003c;
  text-decoration: none;
  margin-right: 1em;
  padding-bottom: 0.1em;
}

.list-empty:hover {
  color: #777776;
  text-decoration: none;
}

.list-empty-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-block: 2em;
  width: 100%;
  gap: 1em;
  color: #777776;
}
.list-empty-container .material-symbols-outlined {
  font-size: 2em;
}

.list-empty-text {
  font-size: 1.6em;
  color: #777776;
}

.list-empty-feedback {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.list-empty-secondary-text {
  color: #7c7c7c;
  font-size: 0.8em;
}

.url-cell {
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/components/list/list.scss","webpack://./src/sass/globals/mixins.scss","webpack://./src/sass/globals/globals.scss"],"names":[],"mappings":"AAIA;EACE,mCAAA,EAAA,oBAAA;EACA,gCAAA,EAAA,gBAAA;EACA,kBAAA,EAAA,yCAAA;EAEA,iDAAA;AAJF;AAKE;EACE,UAAA;AAHJ;AAME;EACE,sBAAA;EACA,kBAAA;AAJJ;AAOE;EACE,sBAAA;AALJ;;AAUA;EClBC,aAAA;EACA,sBAAA;EACA,2BDiBqB;EChBrB,mBDgBiC;EAChC,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,YAAA;EACA,sBAAA;AAJF;AAME;EACE,WAAA;AAJJ;AAKI;EACE,UAAA;EACA,WAAA;EACA,oBAAA;EACA,iBAAA;AAHN;AAMI;;EAEE,kBAAA;EACA,cAAA;EACA,YAAA;AAJN;AAOI;EACE,+BAAA;AALN;AAQI;;EAEE,WAAA;AANN;AAUE;EACE,4CAAA;EACA,YAAA;EACA,oBErDG;AF6CP;AASI;EACE,iCAAA;EACA,YAAA;EACA,oBEzDC;AFkDP;AAUE;EACE,YAAA;EACA,iCAAA;EACA,YAAA;EACA,oBEhEG;AFwDP;AAUE;EACE,+CAAA;EACA,YAAA;EACA,oBErEG;AF6DP;AAUE;EACE,iCAAA;EACA,YAAA;EACA,oBE1EG;AFkEP;AAUE;EACE,iCAAA;EACA,YAAA;EACA,oBE/EG;AFuEP;;AAWA;EACE,WAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AARF;AASE;EACE,YAAA;AAPJ;;AAUA;EACE,sBExGM;EFyGN,kBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AAPF;;AAUA;EClHC,aAAA;EACA,8BDkHe;ECjHf,mBDiH8B;EAC7B,kBAAA;EACA,eAAA;AALF;AAOE;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;AALJ;AAQE;EC7HD,aAAA;EACA,uBD6HiB;EC5HjB,mBD4HyB;EACtB,QAAA;AAJJ;AAOE;EACE,yBAAA;EACA,YAAA;EACA,eAAA;AALJ;AAOI;EACE,cEzIK;AFoIX;AASE;EACE,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;AAPJ;AASI;EAEE,gBAAA;EACA,qBEvJK;AF+IX;AAYE;EAIE,qBAAA;EACA,aAAA;EACA,2BAAA;EACA,sBE9JI;EF+JJ,yBAAA;EACA,cEpKO;EFqKP,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAbJ;AAgBE;EACE,yBE5KO;EF6KP,WEzKI;AF2JR;;AAkBA;EChLC,aAAA;EACA,2BDgLe;EC/Kf,mBD+K2B;EAC1B,WAAA;EACA,QAAA;AAbF;;AAgBA;ECtLC,aAAA;EACA,uBDsLe;ECrLf,mBDqLuB;EACtB,QAAA;AAXF;;AAcA;EC3LC,aAAA;EACA,8BD2Le;EC1Lf,mBD0L8B;EAC7B,6BAAA;EACA,YAAA;EACA,SAAA;AATF;AAWE;ECjMD,aAAA;EACA,2BDiMiB;EChMjB,mBDgM6B;EAC1B,eAAA;EACA,QAAA;AAPJ;AAUE;EACE,yBAAA;EACA,cEnMQ;EFoMR,eAAA;AARJ;AAUI;EACE,cE9MK;AFsMX;AAYE;EACE,aAAA;EACA,yBAAA;EACA,UAAA;AAVJ;AAaE;EACE,mBAAA;AAXJ;AAcE;EACE,cEtNQ;AF0MZ;AAeE;ECzND,aAAA;EACA,sBAAA;EACA,uBDwNuB;ECvNvB,uBDuN+B;EAC5B,eAAA;AAVJ;AAYI;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAVN;AAaI;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;AAXN;;AAgBA;EACE,UAAA;AAbF;;AAgBA;EClPC,aAAA;EACA,sBAAA;EACA,uBDiPqB;EChPrB,uBDgP6B;EAC5B,QAAA;EACA,YAAA;AAVF;;AAaA;ECxPC,aAAA;EACA,sBAAA;EACA,uBDuPqB;ECtPrB,uBDsP6B;EAC5B,QAAA;EACA,YAAA;EACA,gCAAA;AAPF;;AAUA;EACE,eAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AAPF;;AAUA;EACE,yBAAA;EACA,eAAA;AAPF;;AAUA;EACE,oCAAA;EACA,eAAA;EACA,YAAA;AAPF;;AAUA;EC1RC,aAAA;EACA,uBD0Re;ECzRf,mBDyRuB;EACtB,WAAA;EACA,YAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;AALF;AAOE;EAEE,gBAAA;EACA,qBE5SO;AFsSX;;AAUA;EACE,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,cElTU;EFmTV,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAPF;;AAUA;EC/TC,aAAA;EACA,8BD+Te;EC9Tf,mBD8T8B;EAC7B,mBAAA;EACA,gBAAA;EACA,kBAAA;AALF;;AAQA;EACE,eAAA;AALF;;AAQA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,6BAAA;EACA,yDAAA;AALF;;AAQA;EACE,cExVS;AFmVX;;AAQA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,6BAAA;EACA,yDAAA;AALF;;AAQA;ECtWC,aAAA;EACA,uBDsWe;ECrWf,mBDqWuB;EACtB,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AAHF;;AAMA;EClXC,aAAA;EACA,uBDkXe;ECjXf,mBDiXuB;EACtB,eAAA;EACA,WAAA;EACA,oBAAA;EACA,aAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,yBEhYS;EFiYT,WE7XM;AF4XR;;AAIA;EACE,aAAA;EACA,sBAAA;AADF;;AAIA;EACE,iBAAA;EACA,kBAAA;AADF;;AAUA;ECnZC,aAAA;EACA,uBDmZe;EClZf,mBDkZuB;EACtB,iBAAA;EACA,WAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,kBAAA;EACA,cEhaS;EFiaT,qBAAA;EACA,iBAAA;EACA,qBAAA;AALF;;AAQA;EACE,cEhaU;EFiaV,qBAAA;AALF;;AAQA;EC1aC,aAAA;EACA,uBD0ae;ECzaf,mBDyauB;EACtB,iBAAA;EACA,WAAA;EACA,QAAA;EACA,cEzaU;AFsaZ;AAKE;EACE,cAAA;AAHJ;;AAOA;EACE,gBAAA;EACA,cElbU;AF8aZ;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,cAAA;EACA,gBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAJF","sourcesContent":["@import \"../../sass/globals/globals.scss\";\n@import \"../../sass/globals/mixins.scss\";\n\n\n.scroll-visible {\n  -ms-overflow-style: auto !important;  /* For IE and Edge */\n  scrollbar-width: auto !important;     /* For Firefox */\n  overflow-y: scroll;        /* Ensure vertical scrollbar is enabled */\n\n  /* Additional styling for WebKit-based browsers */\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #888;\n    border-radius: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: #555;\n  }\n}\n\n\n.list-container {\n  @include flexColumn(flex-start, center);\n  overflow-y: scroll;\n  padding: 1em;\n  padding-bottom: 0;\n  flex: 1;\n  height: 100%;\n  box-sizing: border-box;\n\n  table {\n    width: 100%;\n    img {\n      width: 3em;\n      height: 3em;\n      border-radius: 0.5em;\n      object-fit: cover;\n    }\n\n    td,\n    th {\n      font-size: 0.875em;\n      padding: 0.5em;\n      color: black;\n    }\n\n    tr:not(:last-child):not(:first-child) {\n      border-block: 2px solid $grey;\n    }\n\n    thead,\n    tbody {\n      width: 100%;\n    }\n  }\n\n  .btn-update {\n    background-color: rgb(143 0 60) !important;\n    border: none;\n    font-family: $font;\n    .btn-primary {\n      background-color: rgb(143 0 60);\n      border: none;\n      font-family: $font;\n    }\n  }\n  .btn-update:hover {\n    opacity: 0.8;\n    background-color: rgb(143 0 60);\n    border: none;\n    font-family: $font;\n  }\n  .btn-update:disabled {\n    background-color: rgb(199, 199, 199) !important;\n    border: none;\n    font-family: $font;\n  }\n  .btn-primary {\n    background-color: rgb(143 0 60);\n    border: none;\n    font-family: $font;\n  }\n  .btn-primary:active {\n    background-color: rgb(143 0 60);\n    border: none;\n    font-family: $font;\n  }\n}\n.list-header-input-number {\n  width: 70px;\n}\n\n.row-slideDuration {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-right: 4rem;\n  input {\n    margin: 15px;\n  }\n}\n.list {\n  background-color: $white;\n  border-radius: 1em;\n  padding: 1em;\n  width: 95%;\n  margin-bottom: 3em;\n}\n\n.list-header {\n  @include flex(space-between, center);\n  padding-block: 1em;\n  flex-wrap: wrap;\n\n  &-title {\n    font-size: 1.1em;\n    font-weight: bold;\n    margin-left: 1em;\n  }\n\n  &-action-group {\n    @include flex(center, center);\n    gap: 1em;\n  }\n\n  &-filter-icon {\n    font-size: 2em !important;\n    color: black;\n    cursor: pointer;\n\n    &:hover {\n      color: $dark-red;\n    }\n  }\n\n  &-input {\n    padding: 1em;\n    border-radius: 0.5em;\n    border: 1px solid #dcdcdc;\n    margin-top: 0.3em;\n    height: 2.5em;\n\n    &:active,\n    &:focus {\n      box-shadow: none;\n      border-color: $dark-red;\n    }\n  }\n\n  &-action,\n  &-action:focus,\n  &-action:hover,\n  &-action:active {\n    text-decoration: none;\n    outline: none;\n    box-shadow: none !important;\n    background-color: $white;\n    border: 1px solid $dark-red;\n    color: $dark-red;\n    padding-inline: 2em;\n    border-radius: 8px;\n    height: 2em;\n    line-height: 2em;\n  }\n\n  &-action:hover {\n    background-color: $dark-red;\n    color: $white;\n  }\n}\n\n.list-headers {\n  @include flex(flex-start, center);\n  width: 100%;\n  gap: 1em;\n}\n\n.list-header-main {\n  @include flex(center, center);\n  gap: 1em;\n}\n\n.list-element {\n  @include flex(space-between, center);\n  border-top: 2px solid #eeedec;\n  padding: 6px;\n  flex: 1;\n\n  &-fields {\n    @include flex(flex-start, center);\n    flex-wrap: wrap;\n    gap: 1em;\n  }\n\n  &-action {\n    font-size: 2em !important;\n    color: $dark-grey;\n    cursor: pointer;\n\n    &:hover {\n      color: $dark-red;\n    }\n  }\n\n  &-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.5em;\n  }\n\n  &-primary-text {\n    font-weight: normal;\n  }\n\n  &-secondary-text {\n    color: $dark-grey;\n  }\n\n  &-text-container {\n    @include flexColumn(center, flex-start);\n    flex-wrap: wrap;\n\n    & > .list-element-primary-text {\n      display: block;\n      width: 38em;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n\n    & > .list-element-primary {\n      display: block;\n      width: 11em;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n  }\n}\n\n.sort-tabs > li > button {\n  width: 8em;\n}\n\n.filter-parameters {\n  @include flexColumn(center, flex-start);\n  gap: 1em;\n  padding: 1em;\n}\n\n.filter-general {\n  @include flexColumn(center, flex-start);\n  gap: 1em;\n  padding: 1em;\n  border-bottom: 1px solid $grey2;\n}\n\n.filter-option {\n  cursor: pointer;\n  width: 100%;\n  height: 2em;\n  padding: 0.1em;\n  padding-left: 1em;\n  line-height: 2em;\n  box-sizing: border-box;\n}\n\n.filter-option:hover {\n  background-color: #f8b8d3;\n  cursor: pointer;\n}\n\n.filter-selected-option {\n  background-color: #c4145d !important;\n  cursor: pointer;\n  color: white;\n}\n\n.filter-input {\n  @include flex(center, center);\n  width: 100%;\n  padding: 1em;\n}\n\n.list-filter-input {\n  width: 100%;\n  padding: 1em;\n  border-radius: 0.5em;\n  border: 1px solid #dcdcdc;\n  margin-top: 0.3em;\n  height: 2.5em;\n\n  &:active,\n  &:focus {\n    box-shadow: none;\n    border-color: $dark-red;\n  }\n}\n\n.filter-member-name {\n  font-weight: bold;\n  max-width: 40%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.filter-member-type {\n  color: $dark-grey;\n  max-width: 50%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.filter-member-row {\n  @include flex(space-between, center);\n  padding-inline: 2em;\n  line-height: 3em;\n  position: relative;\n}\n\n.filter-member-row:hover {\n  cursor: pointer;\n}\n\n.filter-member-row:hover::before {\n  content: \"\";\n  position: absolute;\n  left: 0em;\n  top: 1.25em;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 4px 0 4px 6.9px;\n  border-color: transparent transparent transparent #648acf;\n}\n\n.filter-member-selected {\n  color: $dark-red;\n}\n\n.filter-member-selected::before {\n  content: \"\";\n  position: absolute;\n  left: 0em;\n  top: 1.25em;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 4px 0 4px 6.9px;\n  border-color: transparent transparent transparent #648acf;\n}\n\n.sort-buttons {\n  @include flex(center, center);\n  margin: 2em;\n  font-size: 0.675em;\n  border-radius: 0.5em;\n  border: 1px solid $grey2;\n  height: 3em;\n  padding-inline: 0.225em;\n  width: 20em;\n  align-self: center;\n}\n\n.sort-button {\n  @include flex(center, center);\n  cursor: pointer;\n  width: 100%;\n  border-radius: 0.5em;\n  height: 2.5em;\n}\n\n.sort-buttons-disabled {\n  display: none;\n}\n\n.sort-button-selected {\n  background-color: $dark-red;\n  color: $white;\n}\n\n.filter-general-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.filter-title {\n  font-size: 0.75em;\n  margin-left: 2.6em;\n}\n\n// @media screen and (max-width: 1320px) {\n//   .list-element-column {\n//     display: none;\n//   }\n// }\n\n.list-loading-spinner-container {\n  @include flex(center, center);\n  margin-block: 2em;\n  width: 100%;\n}\n\n.list-loading-spinner {\n  margin-block: 2em;\n}\n\n.list-empty {\n  align-self: center;\n  color: $dark-red;\n  text-decoration: none;\n  margin-right: 1em;\n  padding-bottom: 0.1em;\n}\n\n.list-empty:hover {\n  color: $dark-grey;\n  text-decoration: none;\n}\n\n.list-empty-container {\n  @include flex(center, center);\n  margin-block: 2em;\n  width: 100%;\n  gap: 1em;\n  color: $dark-grey;\n\n  .material-symbols-outlined {\n    font-size: 2em;\n  }\n}\n\n.list-empty-text {\n  font-size: 1.6em;\n  color: $dark-grey;\n}\n\n.list-empty-feedback {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.list-empty-secondary-text {\n  color: #7c7c7c;\n  font-size: 0.8em;\n}\n\n.url-cell {\n  max-width: 200px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  display: block;\n}\n","@mixin flex($justify-content, $align-items) {\n\tdisplay: flex;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n\n@mixin flexColumn($justify-content, $align-items) {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n","$dark-red: #8f003c;\n$sidebar-selected-color: #c4145d;\n$sidebar-logo-color: #a53363;\n$logo-color: #920942;\n$white: #fff;\n$grey: #f3f6f9;\n$grey2: #e2e5e7;\n$dark-grey: #777776;\n$font-color: #fff;\n$shadow-color: #4e7da2;\n$font: 'Rubik';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
